// extracted by mini-css-extract-plugin
module.exports = {"navWrapper":"MobileMainSection_navWrapper__3Zx0l"};